/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Fila ticket contable: label | monto tabular.
 */
import React from 'react';
import { Text, View } from 'react-native';
import { moneySummaryStyles as styles } from './posMoney.styles';

export type MoneySummaryVariant = 'default' | 'compact' | 'total' | 'discount';

export type MoneySummaryTone = 'default' | 'success' | 'warn';

type MoneySummaryRowProps = {
  label: string;
  value: string;
  variant?: MoneySummaryVariant;
  tone?: MoneySummaryTone;
  testID?: string;
  numberOfLines?: number;
};

export function MoneySummaryRow({
  label,
  value,
  variant = 'default',
  tone = 'default',
  testID,
  numberOfLines = 1,
}: MoneySummaryRowProps) {
  const isCompact = variant === 'compact';
  const isTotal = variant === 'total';
  const isDiscount = variant === 'discount';

  return (
    <View style={styles.row} testID={testID}>
      <Text
        style={[
          styles.label,
          isCompact && styles.labelCompact,
          isDiscount && styles.labelDiscount,
        ]}
        numberOfLines={isDiscount ? 2 : numberOfLines}
      >
        {label}
      </Text>
      <Text
        style={[
          styles.value,
          isCompact && !isTotal && styles.valueCompact,
          isTotal && styles.valueTotal,
          isTotal && isCompact && styles.valueTotalCompact,
          isDiscount && styles.valueDiscount,
          tone === 'success' && styles.valueSuccess,
          tone === 'warn' && styles.valueWarn,
        ]}
        numberOfLines={1}
      >
        {value}
      </Text>
    </View>
  );
}
